import { createMasterDataCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type ComplaintsubcategoryDto = EntityRecord;
export type ComplaintsubcategoryCreateRequest = EntityCreateRequest;
export type ComplaintsubcategoryUpdateRequest = EntityUpdateRequest;

export const complaintSubcategoryApi: CrudApi<ComplaintsubcategoryDto, ComplaintsubcategoryCreateRequest, ComplaintsubcategoryUpdateRequest> = createMasterDataCrudApi({ masterType: "complaint-subcategory" });
